<template>
  <div id="process-config">
    <el-tabs v-model="activeName" v-if="taskType !== 'watch-only'">
      <el-tab-pane label="基础设置" name="first">
        <scroll>
          <taskForm
            :ref="'taskForm' + taskId"
            :disabled="disabled"
            :routerOwnerId="routerOwnerId"
            :task="task"
            :taskType="taskType"
            @groupChange="groupChange"
          />
        </scroll>
      </el-tab-pane>
      <el-tab-pane label="JOB设置" name="second">
        <scroll>
          <show-job-form
            :disabled="disabled"
            :node="node"
            v-if="taskType === 'watch-only'"
          />
          <jobForm ref="jobForm" :disabled="disabled" :node="node" v-else />
        </scroll>
      </el-tab-pane>
      <el-tab-pane label="通知设置" name="third">
        <scroll>
          <noticeForm
            ref="noticeForm"
            :notice="noticeObject"
            :disabled="disabled"
            :groupId="groupId"
          />
        </scroll>
      </el-tab-pane>
      <el-tab-pane label="执行计划" name="four">
        <scroll>
          <processForm
            ref="processForm"
            :taskType="taskType"
            :process="scheduledObject"
            :disabled="disabled"
            @scheduChange="scheduChange"
          />
        </scroll>
      </el-tab-pane>
    </el-tabs>
    <show-job-form :disabled="disabled" :node="node" v-else />
    <config-dialog
      :node="node"
      :taskId="taskId"
      :dialog.sync="dialog"
      @refush="refush"
      @addTab="addTab"
    />
    <div class="button-group build" v-if="taskType === 'build'">
      <el-button size="small" class="process-button" @click="quit">
        取 消
      </el-button>
      <el-button size="small" class="process-button" @click="empty">
        清 空
      </el-button>
      <el-button size="small" type="primary" @click="submit">创 建</el-button>
    </div>
    <div class="button-group watch" v-else-if="taskType === 'watch'">
      <el-button size="small" class="process-button" @click="getHistory">
        执行实例
      </el-button>
      <el-button
        size="small"
        class="process-button"
        @click="runOnce(watchData)"
      >
        单次执行
      </el-button>
      <el-button size="small" class="process-button" @click="copy">
        复 制
      </el-button>
      <el-button size="small" class="process-button" @click="exportJson">
        导 出
      </el-button>
      <el-button size="small" type="danger" @click="deleteTask(watchData)">
        删 除
      </el-button>
      <el-button size="small" type="primary" @click="watchSet">编 辑</el-button>
    </div>
    <div
      class="button-group watch-build"
      v-else-if="taskType === 'watch-build'"
    >
      <el-button size="small" class="process-button" @click="watchQuit"
        >取 消</el-button
      >
      <el-button size="small" type="primary" @click="submit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import taskForm from "./taskForm.vue";
import noticeForm from "./noticeForm.vue";
import processForm from "./processForm.vue";
import jobForm from "./jobForm.vue";
import configDialog from "./configDialog.vue";
import showJobForm from "./showJobForm.vue";
import { Delete, Download } from "@/utils/index";

export default {
  name: "process-config",
  props: {
    node: {
      type: Array
    },
    taskType: {
      type: String,
      default: "build"
    },
    watchData: {
      type: Object
    },
    taskId: {
      type: String,
      default: ""
    },
    routerOwnerId: {
      type: String,
      default: ""
    },
    uuid: {
      type: String
    }
  },
  data() {
    return {
      activeName: "first",
      groupId: null,
      loading: false,
      disabled: false,
      dialog: false,
      task: null,
      noticeObject: null,
      scheduledObject: null
    };
  },
  watch: {
    taskType: {
      immediate: true,
      handler(v) {
        if (v === "watch" || v === "watch-only") {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      }
    },
    watchData: {
      immediate: true,
      handler(v) {
        if (v) {
          this.setForm(v);
        }
      }
    }
  },
  methods: {
    quit() {
      this.$emit("quit");
    },
    empty() {
      this.$emit("empty");
    },
    copy() {
      this.dialog = true;
    },
    watchQuit() {
      this.$emit("setType", "watch");
      this.$nextTick(() => {
        this.$parent.$refs["drage" + this.taskId + this.uuid].setSvg();
        this.$parent.$refs["drage" + this.taskId + this.uuid].renderNode();
      });
    },
    watchSet() {
      this.$emit("setType", "watch-build");
      this.$nextTick(() => {
        this.$parent.$refs["drage" + this.taskId + this.uuid].setSvg();
        this.$parent.$refs["drage" + this.taskId + this.uuid].renderNode();
      });
    },
    submit() {
      let data = {};
      this.$emit("loading", true);

      if (
        this.$parent.$refs["drage" + this.taskId + this.uuid].g.sources()
          .length > 1 ||
        this.$parent.$refs["drage" + this.taskId + this.uuid].g.sinks().length >
          1
      ) {
        this.$message({
          type: "error",
          message: "流程中存在多个未连接job"
        });
        this.loading = false;
        return false;
      }

      this.$refs["taskForm" + this.taskId]
        .validate()
        .then(taskForm => {
          data = {
            appId: taskForm.appId,
            taskName: taskForm.name,
            ownerId: taskForm.ownerId,
            ownerType: "GROUP",
            description: taskForm.desc,
            delProtection: taskForm.delProtection,
            bindExecutor: taskForm.radio ? "true" : "false",
            executorId: taskForm.radio ? taskForm.node : "",
            concurrentOption: taskForm.concurrentOption
          };
          if (taskForm.taskId) {
            data.taskId = taskForm.taskId;
          }
          return this.$refs.noticeForm.validate();
        })
        .then(noticeForm => {
          data.alertSetting = {
            alertEnabled: noticeForm.delivery,
            alertTypes: noticeForm.type,
            sendDefaultDing: noticeForm.sendDefaultDing,
            sendDefaultEmail: noticeForm.sendDefaultEmail,
            alertTargets: (() => {
              let arr = [];
              if (noticeForm.infotype.includes("EMAIL")) {
                arr.push({
                  alertType: "EMAIL",
                  alertAddr: noticeForm.emailAddr
                });
              }
              if (noticeForm.infotype.includes("DINGDING")) {
                arr.push({
                  alertType: "DINGDING",
                  alertAddr: noticeForm.dingAddr
                });
              }
              return arr;
            })(),
            timeOutMinutes:
              noticeForm.timeUnit === "f"
                ? noticeForm.time
                : noticeForm.time * 60
          };
          return this.$refs.processForm.validate();
        })
        .then(processForm => {
          data.scheduled = processForm.scheduled;
          data.scheduleCron = "";
          if (processForm.minute) {
            data.scheduleCron = `0 ${processForm.minute} ${processForm.hour} ${processForm.day} ${processForm.month} ${processForm.week}`;
          }

          return this.$refs.jobForm.validate();
        })
        .then(nodes => {
          data.nodes = nodes.map(node => ({
            nodeId: node.nodeId,
            pkgId: node.pkgId,
            jobName: node.jobName,
            pkgVersion: node.version,
            params: (() => {
              let params = {};
              node.jobParams.forEach(
                job => (params[job.name] = job.defaultValue)
              );
              return params;
            })()
          }));
          data.edges = this.$parent.$refs["drage" + this.taskId + this.uuid].g
            .edges()
            .map(edge => ({
              source: edge.v,
              target: edge.w
            }));
          if (this.taskType === "build") {
            this.pushTask(data);
          } else {
            this.saveTask(data);
          }
        })
        .catch(err => {
          if (err !== "") {
            this.activeName = err;
          }
          this.$emit("loading", false);
        });
    },
    pushTask(data) {
      this.$http
        .post("/gavial/v1/task/admin/task", data)
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${data.taskName} 创建成功!`,
            type: "success",
            duration: 2000
          });
          this.quit();
        })
        .finally(() => {
          this.$emit("loading", false);
        });
    },
    saveTask(data) {
      this.$http
        .post("/gavial/v1/task/admin/task/node/edit", data)
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${data.taskName} 修改成功!`,
            type: "success",
            duration: 2000
          });
          this.$emit("setType", "watch");
          this.$emit("refush");
          this.$nextTick(() => {
            this.$parent.$refs["drage" + this.taskId + this.uuid].setSvg();
          });
        })
        .finally(() => {
          this.$emit("loading", false);
        });
    },
    groupChange(v) {
      this.groupId = v;
    },
    setForm(data) {
      let sche = data.scheduleCron
        ? data.scheduleCron.split(" ")
        : ["", "", "", "", "", ""];
      this.task = {
        taskId: data.taskId,
        name: data.taskName,
        ownerId: data.ownerId,
        desc: data.description,
        radio: !!data.bindExecutor,
        node: data.executorId,
        delProtection: data.delProtection,
        appId: data.appId,
        concurrentOption: data.concurrentOption
      };
      this.scheduledObject = {
        scheduled: data.scheduled,
        minute: sche[1],
        hour: sche[2],
        day: sche[3],
        month: sche[4],
        week: sche[5]
      };
      if (data.alertSetting !== null && data.alertSetting !== undefined) {
        this.noticeObject = {};
        this.noticeObject.delivery = data.alertSetting.alertEnabled;
        this.noticeObject.type = data.alertSetting.alertTypes;
        this.noticeObject.time = data.alertSetting.timeOutMinutes;
        this.noticeObject.sendDefaultDing = data.alertSetting.sendDefaultDing;
        this.noticeObject.sendDefaultEmail = data.alertSetting.sendDefaultEmail;
        this.noticeObject.timeUnit = "f";
        this.noticeObject.infotype = [];
        data.alertSetting.alertTargets.forEach(alert => {
          this.noticeObject.infotype.push(alert.alertType);
          if (alert.alertType === "EMAIL") {
            this.noticeObject.emailAddr = alert.alertAddr;
          } else {
            this.noticeObject.dingAddr = alert.alertAddr;
          }
        });
      }
    },
    refush() {
      this.$emit("refush");
    },
    addTab(data) {
      this.$emit("addTab", data);
    },
    // 执行实例
    getHistory() {
      this.$store.dispatch("setExecute", this.taskId);
      this.$router.push("/flowmanage/executions");
    },
    runOnce(row) {
      this.loading = true;
      this.$http
        .post("/gavial/v1/task/admin/task/execute/start?taskId=" + row.taskId)
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${row.taskName} 开始单次执行`,
            type: "success",
            duration: 2000
          });
          this.refush();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 导出
    exportJson() {
      Download(
        `/gavial/v1/task/admin/task/dump?id=${this.taskId}`,
        `${this.watchData.taskName}.json` || "export.json"
      );
    },
    // 删除
    deleteTask(row) {
      Delete(
        `/gavial/v1/task/admin/task?id=${row.taskId}`,
        row.taskName,
        () => {
          this.refush();
          this.$emit("close");
        },
        bool => {
          this.loading = bool;
        }
      );
    },
    scheduChange(v) {
      if (v) {
        this.runTask(this.watchData);
      } else {
        this.stopTask(this.watchData);
      }
    },
    runTask(row) {
      this.loading = true;
      this.$http
        .post("/gavial/v1/task/admin/task/schedule/start?taskId=" + row.taskId)
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${row.taskName} 开始调度`,
            type: "success",
            duration: 2000
          });
          this.refush();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    stopTask(row) {
      this.loading = true;
      this.$http
        .post("/gavial/v1/task/admin/task/schedule/stop?taskId=" + row.taskId)
        .then(() => {
          this.$notify({
            title: "成功",
            message: `${row.taskName} 停止调度`,
            type: "success"
          });
          this.refush();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {
    taskForm,
    noticeForm,
    jobForm,
    processForm,
    configDialog,
    showJobForm
  }
};
</script>

<style lang="scss">
#process-config {
  flex: 0 0 400px;
  margin-left: var(--padding);
  background: #fff;
  display: flex;
  flex-direction: column;
  .el-tabs {
    height: 100%;
  }
  .button-group {
    position: absolute;
    bottom: 0;
    transform: translate(-50%);
    justify-content: center;
    &.watch-only,
    &.watch {
      left: calc((100% - 400px - var(--padding)) / 2);
    }
    &.build,
    &.watch-build {
      left: calc(
        (100% - 400px - 260px - var(--padding) * 2) / 2 + 260px + var(--padding)
      );
    }
    .process-button {
      background: #f7f7f7;
    }
  }
  .el-tabs__content {
    height: calc(100% - 39px);
    .el-tab-pane {
      height: 100% !important;
      padding: 0 !important;
    }
  }
  .el-tabs__header {
    margin: 0;
    .is-active {
      background: transparent !important;
    }
    .el-tabs__nav-wrap {
      padding: 0 10px;
      &::after {
        height: 1px;
      }
      #tab-first {
        padding-left: 0;
      }
      #tab-four {
        padding-right: 0;
      }
    }
  }
}
</style>
